import React from 'react'
import Link from 'next/link'
import { getTimestamp, getAnchorRel } from '@next-nx/utils'
import { useIsMobile, useTealium } from '@next-nx/hooks'
import { NewsType } from '@next-nx/utils/types'
import { ArrowRight } from '@next-nx/shared-ui/icons'
import { WImage, Button, Tag } from '@next-nx/shared-ui/atoms'
import styles from './ArticoloCard.module.sass'

interface Props {
  news: NewsType
  className?: string
  variant?: 'vertical' | 'horizontal'
  withDataPubblicazione?: boolean
  withCta?: boolean
  ctaLabel?: string
}

const ArticoloCard = (props: Props) => {
  const {
    news = undefined,
    variant = 'vertical',
    withDataPubblicazione = false,
    ctaLabel = '',
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

  const isMobile = variant === 'horizontal' ? useIsMobile() : undefined

  const handleTracking = (action_type: string = '') => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'news',
      action_tech: 'click',
      action_type: action_type.replace(/\.|\/|\s+/g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'lettura_news',
    })
    linkDataLayer({
      virtual: 'action',
      action_name: 'navigazione',
      action_tech: 'click',
      action_type: action_type.replace(/\.|\/|\s+/g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'interazione_componente_news',
    })
  }

  return news ? (
    <Link href={news?.url || '#'}>
      <a
        onClick={() => handleTracking(news?.titolo)}
        rel={getAnchorRel(news?.url || '')}
        className={`${styles.root} ${
          styles[`root--${isMobile ? 'vertical' : variant}`]
        } ${className}`}
      >
        <div className={styles.layout}>
          <div className={`${styles.imageBox}`}>
            <WImage
              src={news?.immagine}
              alt={news?.titolo}
              title={news?.titolo}
              maxWidth={variant === 'vertical' || isMobile ? 350 : 190}
              maxHeight={variant === 'vertical' || isMobile ? 150 : 190}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div className={styles.content}>
            <div className={styles.taglist}>
              {news?.tags.map((tag) => (
                <div className={styles.ButtonSm} key={tag.pk}>
                  <Tag label={tag.nome} color={'blue'} size={'sm'} />
                </div>
              ))}
            </div>
            {!!news.dataPubblicazione && withDataPubblicazione && (
              <div className={styles.dataPubblicazione}>
                <p>{news.dataPubblicazione}</p>
              </div>
            )}
            {!!news.titolo && <div className={styles.title}>{news.titolo}</div>}
            {!!ctaLabel && news.url && (
              <div className={styles.ctaBox}>
                <Button
                  label={ctaLabel}
                  href={news.url}
                  variant="ghost"
                  icon={<ArrowRight />}
                  iconPos="right"
                />
              </div>
            )}
          </div>
        </div>
      </a>
    </Link>
  ) : (
    <></>
  )
}

export default ArticoloCard
